/* ------------------------------------------------------------------ */
/*  src/Firebase.js                                                   */
/* ------------------------------------------------------------------ */
import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";
import { getStorage } from "firebase/storage";

/* ---------- Variables d’environnement (.env.local) ---------- */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// ✅ Logs uniquement en DEV (pas en test / prod)
if (process.env.NODE_ENV === "development") {
  console.log("API KEY PRESENTE ?", !!process.env.REACT_APP_FIREBASE_API_KEY);
  console.log("PROJECT ID :", process.env.REACT_APP_FIREBASE_PROJECT_ID);
}

/* ---------- Initialisation unique ---------- */
const app = getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);

/* ---------- Services Firebase ---------- */
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

/* ---------- Exports ---------- */
export const firebaseApp = app;
export { auth, collection, db, getDocs, query, storage, where };

